export enum PetSpeciesName {
  'Canine' = 'Canine',
  'Feline' = 'Feline',
  'Fish' = 'Fish',
  'Bird' = 'Bird',
  'Reptile' = 'Reptile',
  'Small_Animal' = 'Small Animal',
}
